import React, { ReactNode } from 'react';
import styled from 'styled-components';
//
import Header from 'components/header';
import Sidebar from 'components/sidebar';
import ActionBar from 'components/action-bar';

const StyledLayout = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 59px;
`;

const ContentContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

interface ILayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: ILayoutProps) => {
  return (
    <StyledLayout>
      <Header />
      <MainContainer>
        <Sidebar />
        <ContentContainer>
          <ActionBar />
          {children}
        </ContentContainer>
      </MainContainer>
    </StyledLayout>
  );
};

export default Layout;
